export function craftAssetUrl(url: string) {
    if (url.indexOf('assets/') === 0 || url.indexOf('/assets/') === 0) {
        const assetsUrl = inwink.config.assetsUrl || "/";
        return assetsUrl + (url.indexOf('/') === 0 ? url.substring(1) : url);
    }
    return url;
}